<template>
  <el-dialog
    :title="model.id > 0 ? '编辑区域' : '添加区域'"
    :visible.sync="visible"
    label-width="100px"
    width="500px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="80px"
      size="small"
    >
      <el-form-item label="名称" prop="name">
        <el-input v-model="model.name" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { regionNew, regionUpdate } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {
        name: [{ required: true, message: '请填写名称', trigger: 'blur' }],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.model.id > 0) {
            let res = await regionUpdate(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
              this.visible = false
            }
          } else {
            let res = await regionNew(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
              this.visible = false
            }
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>